module.exports = __webpack_public_path__ + "resources/img/privacy-img.9f080975.png";